
import './TwoThirds.css'
import {useAsset} from "../../AssetHelper";
import { ReactNode } from "react";

export default function TwoThirds({vflip, children} : {
    vflip: boolean,
    children: ReactNode
}) {
    return <div className={`twoThirdsContainer ${vflip ? "vflip" : ""}`}>{children}</div>
}
